
define('text!platform/commonUI/general/res/templates/tree/toggle.html',[],function () { return '<span class=\'ui-symbol view-control flex-elem\'>\n</span>\n';});

